module.exports = __webpack_public_path__ + "static/media/apprentissage.d865baf9.jpg";